import Link  from '../components/link';
import React from 'react';


//  Image button appears in its own section (eg Quickbooks Button)
//
//  href      - Navigate to this URL
//  onClick   - Event handler
//  linkRef   - Reference to link
//  src       - Source of image
//  width     - Width of image button
//  height    - Height of image button
export default function ImageButton({ href, onClick, linkRef, className, external }) {
  return (
    <ul className="list">
      <li>
        <Link
          href={href}
          ref={linkRef}
          onClick={onClick}
          external={external}
          className={className}
        />
      </li>
    </ul>
  );
}
